import {CONSTANTS} from "../constants/constants"
import type {Dimensions, Position} from "../types/types"

export const calculateImageDimensions = (
    img: HTMLImageElement | HTMLVideoElement,
    cropDimensions: Dimensions
): Dimensions => {
    const sourceWidth =
        img instanceof HTMLVideoElement ? img.videoWidth : img.width
    const sourceHeight =
        img instanceof HTMLVideoElement ? img.videoHeight : img.height

    const cropRatio = cropDimensions.width / cropDimensions.height
    const imageRatio = sourceWidth / sourceHeight

    const cropScale = Math.min(
        CONSTANTS.CONTAINER_SIZE / cropDimensions.width,
        CONSTANTS.CONTAINER_SIZE / cropDimensions.height
    )

    const scaledCropWidth = cropDimensions.width * cropScale
    const scaledCropHeight = cropDimensions.height * cropScale

    let width, height

    if (imageRatio > cropRatio) {
        width = scaledCropHeight * imageRatio
        height = scaledCropHeight
    } else {
        width = scaledCropWidth
        height = scaledCropWidth / imageRatio
    }

    if (width === 0 || height === 0 || !isFinite(width) || !isFinite(height)) {
        return {
            width: cropDimensions.width,
            height: cropDimensions.height,
        }
    }

    return {width, height}
}

export const calculateCenterPosition = (dimensions: Dimensions): Position => ({
    x: (CONSTANTS.CONTAINER_SIZE - dimensions.width) / 2,
    y: (CONSTANTS.CONTAINER_SIZE - dimensions.height) / 2,
})

export const calculateMovementLimits = (
    imageSize: Dimensions,
    cropDimensions: Dimensions,
    zoom: number
) => {
    const cropScale = Math.min(
        CONSTANTS.CONTAINER_SIZE / cropDimensions.width,
        CONSTANTS.CONTAINER_SIZE / cropDimensions.height
    )

    const scaledCropWidth = cropDimensions.width * cropScale
    const scaledCropHeight = cropDimensions.height * cropScale

    const cropX = (CONSTANTS.CONTAINER_SIZE - scaledCropWidth) / 2
    const cropY = (CONSTANTS.CONTAINER_SIZE - scaledCropHeight) / 2

    const zoomFactor = zoom / 100
    const zoomedWidth = imageSize.width * zoomFactor
    const zoomedHeight = imageSize.height * zoomFactor

    return {
        minX: cropX - (zoomedWidth - scaledCropWidth),
        maxX: cropX,
        minY: cropY - (zoomedHeight - scaledCropHeight),
        maxY: cropY,
    }
}
